// removes the protocol from a URL, e.g. https://domain.com -> domain.com
const stripProtocol = (url = '') => url.replace(/(^\w+:|^)\/\//, '');

export default stripProtocol;
